import { bootstrapApplication } from '@angular/platform-browser';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

import { App } from './app/app';
import { appConfig } from './app/app-config';

const INSTALLED_KEY = 'youtopia-installed';

async function clearKeychainOnFreshInstall(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  const { value } = await Preferences.get({ key: INSTALLED_KEY });
  if (value) return;

  await SecureStorage.clear();
  await Preferences.set({ key: INSTALLED_KEY, value: 'true' });
}

clearKeychainOnFreshInstall()
  .catch((error) => console.error('[main] clearKeychainOnFreshInstall failed', error))
  .then(() => bootstrapApplication(App, appConfig))
  .catch((error) => console.error('[main] bootstrapApplication failed', error));
